module.exports = __webpack_public_path__ + "img/2.d52fc5bc.png";